import { defineStore } from 'pinia'
import httpClient from '@/api/httpClient'
import store from '@/store'

export const useSqueuesStore = defineStore('squeues', {
  state: () => ({
    squeues: [],
    fetchInitiated: false,
    // Set to true after the HTTP response arrives. SqueueField uses this to
    // withhold the <select> element from the DOM until options are available,
    // which prevents Firefox/Safari from ever seeing a <select> transition
    // from no-options to has-options and firing spurious input events.
    loaded: false,
  }),

  getters: {
    enabled({ squeues }) {
      return squeues.filter(squeue => squeue.enabled)
    },

    enabledAsObject({ squeues }) {
      return squeues.filter(squeue => squeue.enabled).reduce((obj, squeue) => {
        obj[squeue.title] = squeue.id
        return obj
      }, {})
    },

    forId: ({ squeues }) => (id) => {
      return squeues.find(squeue => squeue.id === id)
    },
  },

  actions: {
    async fetch() {
      this.fetchInitiated = true

      return httpClient.get('/api/internal/squeues')
        .then(response => {
          this.squeues = response.data.squeues
          this.loaded = true
        })
        .catch((err) => {
          store.dispatch('messages/smartAdd', err)
        })
    },

    async fetchOnce() {
      if (this.fetchInitiated) return

      return this.fetch()
    },
  },
})
